// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eEV_M","slider":"style_slider__7ymIt","preview":"style_preview__z7VuL"};